import { useMediaQuery } from "react-responsive";
import {
  css,
  CSSObject,
  FlattenSimpleInterpolation,
  SimpleInterpolation,
} from "styled-components";

const thresholdWidth = 768;

export const media = {
  sp: (
    first: CSSObject | TemplateStringsArray,
    ...interpolations: SimpleInterpolation[]
  ): FlattenSimpleInterpolation => css`
    @media (max-width: ${thresholdWidth}px) {
      ${css(first, ...interpolations)}
    }
  `,
  pc: (
    first: CSSObject | TemplateStringsArray,
    ...interpolations: SimpleInterpolation[]
  ): FlattenSimpleInterpolation => css`
    @media (min-width: ${thresholdWidth}px) {
      ${css(first, ...interpolations)}
    }
  `,
} as const;

export const useSpQuery = () => {
  const isSp = useMediaQuery({ query: `(max-width: ${thresholdWidth}px)` });
  return isSp;
};
